import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import HighlightBadgeNodeView from './HighlightBadgeNodeView.vue'
import { normalizeHexColor } from './colorAttributes'

const DEFAULT_BORDER_COLOR = '#045DB5'
const DEFAULT_TEXT_COLOR = '#045DB5'
const DEFAULT_BACKGROUND_COLOR = '#eaf1fb'

export const HighlightBadgeNode = Node.create({
  name: 'highlightBadge',

  group: 'block',

  content: 'inline*',

  marks: 'bold italic strike underline link',

  defining: true,

  addAttributes() {
    return {
      borderColor: {
        default: DEFAULT_BORDER_COLOR,
        parseHTML: element => normalizeHexColor(element.getAttribute('data-border-color')) || DEFAULT_BORDER_COLOR,
        renderHTML: attributes => ({ 'data-border-color': attributes.borderColor }),
      },
      textColor: {
        default: DEFAULT_TEXT_COLOR,
        parseHTML: element => normalizeHexColor(element.getAttribute('data-text-color')) || DEFAULT_TEXT_COLOR,
        renderHTML: attributes => ({ 'data-text-color': attributes.textColor }),
      },
      backgroundColor: {
        default: DEFAULT_BACKGROUND_COLOR,
        parseHTML: element => normalizeHexColor(element.getAttribute('data-background-color')) || DEFAULT_BACKGROUND_COLOR,
        renderHTML: attributes => ({ 'data-background-color': attributes.backgroundColor }),
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="highlight-badge"]',
        contentElement: 'div',
      },
    ]
  },

  renderHTML({ HTMLAttributes, node }) {
    const { borderColor, textColor, backgroundColor } = node.attrs
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'highlight-badge',
        style: 'display:flex;justify-content:center;margin-top:8px;',
      }),
      [
        'div',
        {
          style: `display:inline-block;padding:6px 14px;border:1px solid ${borderColor};border-radius:20px;font-size:13px;text-align:center;color:${textColor};background:${backgroundColor};`,
        },
        0,
      ],
    ]
  },

  addNodeView() {
    return VueNodeViewRenderer(HighlightBadgeNodeView)
  },

  addCommands() {
    return {
      insertHighlightBadge: (attrs = {}) => ({ chain }) => {
        return chain()
          .insertContent({
            type: this.name,
            attrs,
          })
          .run()
      },
    }
  },
})

export default HighlightBadgeNode
